import React from 'react';
export const ModalFooter = ({ children }) => React.createElement("div", { className: "modal__footer" }, children);
//# sourceMappingURL=ModalFooter.js.map